import { useEffect, useState } from "react";
import { fetchPricing } from "./api";

// Module-level cache so every component shares one fetch (one source of truth).
let _cache = null;
let _inflight = null;

const FALLBACK = {
  amount: 6.99,
  currency: "usd",
  interval: "month",
  formatted: "$6.99",
  configured: false,
};

// Returns the live Pro price read from Stripe: { amount, currency, interval,
// formatted }. Falls back to $6.99/mo until the request resolves.
export function usePricing() {
  const [pricing, setPricing] = useState(_cache || FALLBACK);

  useEffect(() => {
    if (_cache) {
      setPricing(_cache);
      return;
    }
    if (!_inflight) {
      _inflight = fetchPricing()
        .then((p) => {
          _cache = p;
          return p;
        })
        .catch(() => FALLBACK)
        .finally(() => {
          _inflight = null;
        });
    }
    let active = true;
    _inflight.then((p) => {
      if (active) setPricing(p || FALLBACK);
    });
    return () => {
      active = false;
    };
  }, []);

  return pricing;
}
